// extracted by mini-css-extract-plugin
export var deliveryRow = "_qs-a";
export var fixedHeight = "_qs-4";
export var freightLogo = "_qs-9";
export var fullWidth = "_qs-3";
export var priceColumn = "_qs-5";
export var radioSelected = "_qs-7";
export var radioUnselected = "_qs-6";
export var selectedOption = "_qs-2";
export var selectedOptionContainer = "_qs-1";
export var selection = "_qs-0";
export var tallSkeletonText = "_qs-8";